import {
    FormDatePicker,
    FormField,
    FormFieldCheckbox,
} from '@/global/components/Form'
import CheckboxBase from '@/global/components/Form/Base/Checkbox'
import IconeAjuda from '@/global/components/IconeAjuda'
import { Link } from '@/global/components/Link'
import Menu from '@/global/components/MenuV2'
import { Empresa } from '@/service/api/endpoints/empresas'
import { LayoutFolha } from '@acme/core'
import { Alert, Divider, Grid, Switch } from '@mui/material'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { horariosCalculoAutomatico } from '../../constants/horarios'
import Digitacao from './DadosPonto/Digitacao'

export default function EmpresaPontoForm() {
    return (
        <section id="dados-ponto" className="flex gap-6 flex-col">
            <AdicionalNoturno /> {/* campos sendo migrados */}
            <Relatorios />
            <BancoHoras />
            <IntegracaoFolha />
            <CalculoAutomatico />
            <Justificativas />
            <Digitacao />
        </section>
    )
}

function Relatorios() {
    return (
        <section id="relatorios">
            <Divider className="select-none mb-4">Relatórios</Divider>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <FormField
                        name="diasRescisao"
                        type="number"
                        label="Dias de exibição de funcionários desligados"
                        InputProps={{
                            endAdornment: (
                                <IconeAjuda>
                                    Essa é a quantidade de dias após a rescisão
                                    que os funcionários serão listados em
                                    relatórios e na tela de digitação. Após esse
                                    período, o funcionário não será mais exibido
                                    e será listado apenas em relatórios de
                                    competências anteriores.
                                    <br />
                                    <br />
                                    Esse campo também controla a exibição dos
                                    funcionários na tela de cadastros de centros
                                    de custo.
                                </IconeAjuda>
                            ),
                        }}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={6}
                    className="inline-flex items-start mt-2"
                >
                    <FormFieldCheckbox
                        name="exibirSaldoDiario"
                        label="Exibir saldo diário na digitação"
                    />
                    <IconeAjuda>
                        Caso marcado, uma coluna a mais será exibida na tela de
                        digitação de ponto, mostrando a diferença do saldo
                        diário do funcionário (extras - faltas).
                    </IconeAjuda>
                </Grid>
            </Grid>
        </section>
    )
}

function BancoHoras() {
    const { watch, setValue } = useFormContext()

    const [periodoFechamentoPonto] = watch(['periodoFechamentoPonto'])

    const [usarBancoHoras, setUsarBancoHoras] = useState(
        !!periodoFechamentoPonto,
    )

    return (
        <section id="banco-horas">
            <Divider className="select-none mb-4">Banco de horas</Divider>
            <Grid container spacing={2}>
                <Grid item xs={12} className="inline-flex items-center">
                    <CheckboxBase
                        checked={usarBancoHoras}
                        onChange={(_, checked) => {
                            if (!checked) {
                                setValue('periodoFechamentoPonto', 0)
                            }

                            setUsarBancoHoras(checked)
                        }}
                        className="px-4 mt-2"
                    >
                        Utilizar banco de horas
                    </CheckboxBase>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        name="periodoFechamentoPonto"
                        type="number"
                        placeholder="Meses"
                        label="Período de fechamento do ponto (em meses)"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        hidden={!usarBancoHoras}
                        InputProps={{
                            endAdornment: (
                                <IconeAjuda className="mt-1">
                                    Período de fechamento do banco de horas
                                    significa que após o término do período
                                    informado, todas as horas extras e faltas
                                    dos funcionarios serão zeradas, iniciando
                                    assim um novo período de banco de horas.
                                </IconeAjuda>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormDatePicker
                        name="proximoFechamentoPonto"
                        type="month"
                        label="Competência do próximo fechamento"
                        hidden={!usarBancoHoras}
                    />
                </Grid>
            </Grid>
        </section>
    )
}

/** @deprecated */
function AdicionalNoturno() {
    return (
        <section id="adicional-noturno">
            <Divider className="select-none mb-4 line-through">
                Adicional noturno
            </Divider>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Alert severity="warning">
                        A configuração de adicional noturno foi movida para{' '}
                        <Link href="/cadastros/regras-calculo">
                            regras de cálculo
                        </Link>
                        . Configure o quanto antes sua regra de cálculo para
                        garantir que o adicional noturno seja calculado
                        corretamente.
                    </Alert>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={5}
                    className="flex flex-row items-center mt-2"
                >
                    <FormFieldCheckbox
                        name="temAdicionalNoturno"
                        label="Tem adicional noturno"
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={7}>
                    <FormField
                        name="tmp_ramo"
                        label="Ramo do adicional noturno"
                        select
                        disabled
                        SelectProps={{
                            MenuProps: {
                                PaperProps: {
                                    sx: {
                                        width: 192,
                                        marginLeft: 0,
                                    },
                                },
                            },
                        }}
                    >
                        <Menu.Item value={-1}>Outro ramo</Menu.Item>
                        <Menu.Item value={1}>Urbano</Menu.Item>
                        <Menu.Item value={2}>Agrícola</Menu.Item>
                        <Menu.Item value={3}>Pecuária</Menu.Item>
                    </FormField>
                </Grid>
                <Grid item xs={12} sm={12 / 3}>
                    <FormField
                        name="horarioInicioAdicionalNoturno"
                        type="time"
                        label="Início do adicional noturno"
                        required
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={12 / 3}>
                    <FormField
                        name="horarioFimAdicionalNoturno"
                        type="time"
                        label="Fim do adicional noturno"
                        required
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={12 / 3}>
                    <FormField
                        name="horarioEncerramentoAdicionalNoturno"
                        type="time"
                        label="Fim da extensão"
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="flex items-center w-full select-none">
                        <FormFieldCheckbox
                            name="reducaoHrsATrabalhar"
                            label="Redução de horas a trabalhar"
                            disabled
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="flex items-center w-full select-none">
                        <FormFieldCheckbox
                            name="reducaoSomenteAdicionalNoturno"
                            label="Redução sobre adicional noturno"
                            disabled
                        />
                    </div>
                </Grid>
            </Grid>
        </section>
    )
}

function IntegracaoFolha() {
    return (
        <section id="integracao-folha">
            <Divider className="select-none mb-4">
                Integração com a folha de pagamento
            </Divider>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={5}>
                    <FormField
                        name="codEmpresaFolha"
                        label="Código da empresa"
                        InputProps={{
                            endAdornment: (
                                <IconeAjuda>
                                    Caso use integração com folha de pagamento,
                                    informe o código da empresa no seu sistema
                                    de folha de pagamento.
                                </IconeAjuda>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={7}>
                    <FormField
                        name="layoutFolha"
                        label="Layout de exportação"
                        select
                        InputProps={{
                            endAdornment: (
                                <IconeAjuda className="mr-4">
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div
                                            style={{
                                                maxWidth: '50%',
                                                overflowWrap: 'break-word',
                                            }}
                                        >
                                            Essa configuração define como os
                                            dados serão exportados para a folha
                                            de pagamento.
                                        </div>
                                        <div>
                                            <span>F - Funcionário</span>
                                            <br />
                                            <span>C - Competência</span>
                                            <br />
                                            <span>R - Rubrica</span>
                                            <br />
                                            <span>V - Valor</span>
                                            <br />
                                            <span>E - Empresa</span>
                                            <br />
                                            <span>P - Pis</span>
                                            <br />
                                            <span>H - Horas</span>
                                            <br />
                                            <span>M - Minutos</span>
                                        </div>
                                    </div>
                                    <br />
                                    <br />
                                    <div
                                        style={{
                                            overflowWrap: 'break-word',
                                            overflowY: 'auto',
                                            maxHeight: '150px',
                                        }}
                                    >
                                        <li>
                                            <strong>Domínio</strong>:<br />
                                            10FFFFFFFFFFCCCCCCRRRR11VVVVVVVVVEEEEEEEEEE
                                        </li>
                                        <li>
                                            <strong>Fortes</strong>:
                                            <br />
                                            1FFFFFFRRRvvvvvvv.vvVVVVVVVVVVVV.VV
                                        </li>
                                        <li>
                                            <strong>Questor 01</strong>:
                                            <br />
                                            0;EEEE;000;FFFFFFFFF;RRRR;0000;vvvvvvvvvvv;VVVVVVVVVVV;
                                        </li>
                                        <li>
                                            <strong>Questor 02</strong>:
                                            <br />
                                            EEE;FFFFFF;RRR;VVVVV;vvvvvvvvv;
                                        </li>
                                        <li>
                                            <strong>Questor 03</strong>:
                                            <br />
                                            EEEE;FFFFFF;RRR;VVV,VV
                                        </li>
                                        <li>
                                            <strong>System</strong>:
                                            <br />
                                            RRRRFFFFFFvvvv.vvVVVVVVVVVVVV.VV
                                        </li>
                                        <li>
                                            <strong>Data Cempro</strong>:
                                            <br />
                                            FFFFFFFFFFRRRRVVV:VV:VVPPPPPPPPPPP
                                        </li>
                                        <li>
                                            <strong>Via Soft</strong>:
                                            <br />
                                            FFFFFFFFFFFRRRRRHHHMM
                                        </li>
                                    </div>
                                </IconeAjuda>
                            ),
                        }}
                    >
                        <Menu.Item value={LayoutFolha.DOMINIO}>
                            Domínio (Horas)
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.DOMINIO_DECIMAL}>
                            Domínio (Decimal)
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.FORTES_5}>
                            Fortes v5
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.FORTES_6}>
                            Fortes v6
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.QUESTOR_01}>
                            Questor 01
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.QUESTOR_02}>
                            Questor 02
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.QUESTOR_03}>
                            Questor 03
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.SYSTEM}>System</Menu.Item>
                        <Menu.Item value={LayoutFolha.DATA_CEMPRO}>
                            Data Cempro
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.VIASOFT}>
                            Via Soft
                        </Menu.Item>
                    </FormField>
                </Grid>
                <Grid item xs={12} sm={6} className="inline-flex items-center">
                    <FormFieldCheckbox
                        name="exportarHorasFaltaJustificada"
                        label="Exportar faltas justificadas em horas"
                    />
                    <IconeAjuda>
                        Caso esteja marcado, as faltas justificadas e
                        injustificadas serão exportadas em horas, caso
                        contrário, serão exportadas em dias. Quando banco de
                        horas está habilitado, apenas as faltas da competência
                        atual serão exportadas em dias.
                    </IconeAjuda>
                </Grid>
                <Grid item xs={12} sm={5} className="inline-flex items-center">
                    <FormFieldCheckbox
                        name="exportarHorasFaltaIntegral"
                        label="Exportar faltas integrais em horas"
                    />
                    <IconeAjuda>
                        Caso esteja marcado, as faltas integrais serão
                        exportadas em horas, caso contrário, serão exportadas em
                        dias. Não é compatível com banco de horas.
                    </IconeAjuda>
                </Grid>
            </Grid>
        </section>
    )
}

function CalculoAutomatico() {
    const { watch, setValue } = useFormContext()

    const hrCalculoAutomatico = watch('hrCalculoAutomatico')
    const calculoAutomatico = watch('calculoAutomatico')

    return (
        <section id="calculo-automatico">
            <Divider className="select-none mb-4">
                <span className="inline-flex items-center">
                    Cálculo automático&nbsp;
                    <IconeAjuda>
                        O cálculo automático é realizado uma vez ao dia, no
                        horário selecionado. Ele é responsável por gerar os
                        espelhos de ponto e calcular as jornadas de trabalho de
                        todos os funcionários da empresa.
                        <br />
                        <br />
                        Se o cálculo automático estiver desabilitado, você
                        precisará realizar o cálculo manualmente através do
                        botão "Calcular ponto" na tela de digitação ou de
                        cálculo de ponto sempre que desejar atualizar os
                        espelhos e saldos dos funcionários.
                    </IconeAjuda>
                </span>
            </Divider>
            <Grid container spacing={1} columnSpacing={2}>
                <Grid
                    item
                    xs={12}
                    sm={6}
                    className="inline-flex items-start mt-2"
                >
                    <FormFieldCheckbox
                        name="calculoAutomatico"
                        label="Habilitar cálculo automático"
                        defaultChecked={!!hrCalculoAutomatico}
                        onChange={(_, checked) => {
                            if (checked) {
                                setValue('hrCalculoAutomatico', null)
                            } else {
                                setValue('hrCalculoAutomatico', -1)
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        id="hrCalculoAutomatico"
                        name="hrCalculoAutomatico"
                        label="Horário do cálculo automático"
                        select
                        disabled={!calculoAutomatico}
                    >
                        <Menu.Item value={-1} disabled>
                            Selecione uma opção
                        </Menu.Item>
                        {horariosCalculoAutomatico.map((horario, index) => (
                            <Menu.Item key={index} value={horario}>
                                {horario}
                            </Menu.Item>
                        ))}
                    </FormField>
                </Grid>
            </Grid>
        </section>
    )
}

function Justificativas() {
    const { watch, setValue } = useFormContext<Empresa>()
    const justificativa = watch('justificativaPadraoRegistro')

    const [exigirJustificativa, setExigirJustificativa] = useState(
        justificativa == undefined,
    )

    return (
        <section id="justificativas">
            <Divider className="select-none mb-4">Justificativas</Divider>
            <Grid container spacing={2}>
                <Grid item xs={12} className="inline-flex items-center">
                    <Switch
                        checked={exigirJustificativa}
                        onChange={() =>
                            setExigirJustificativa(prev => {
                                if (!prev) {
                                    setValue(
                                        'justificativaPadraoRegistro',
                                        null,
                                    )
                                    return true
                                }
                                setValue(
                                    'justificativaPadraoRegistro',
                                    'Inserido manualmente',
                                )
                                return false
                            })
                        }
                    />
                    <label>Exigir justificativa ao incluir registros</label>
                    <IconeAjuda>
                        <p>
                            Quando habilitado, sempre que um registro manual for
                            inserido na digitação, uma justificativa será
                            exigida para a inserção do registro.
                        </p>
                        <br />
                        <p>
                            Quando desabilitado, a justificativa padrão será
                            utilizada.
                        </p>
                    </IconeAjuda>
                </Grid>
                <Grid item xs={12}>
                    <FormField
                        name="justificativaPadraoRegistro"
                        label="Justificativa padrão"
                        rows={5}
                        multiline
                        disabled={exigirJustificativa}
                        max={190}
                    />
                </Grid>
            </Grid>
        </section>
    )
}
